type DirectionsLocation = {
	latitude?: number | null
	longitude?: number | null
	address?: string | null
	city?: string | null
	state?: string | null
	zip?: string | null
	dealer_name?: string | null
}

function hasValidCoordinates(latitude?: number | null, longitude?: number | null): boolean {
	return (
		latitude != null &&
		longitude != null &&
		Number.isFinite(latitude) &&
		Number.isFinite(longitude)
	)
}

function formatAddressQuery({
	address,
	city,
	state,
	zip,
	dealer_name,
}: DirectionsLocation): string {
	return [dealer_name, address, city, state, zip].filter(Boolean).join(', ')
}

function isAppleDevice(): boolean {
	if (typeof navigator === 'undefined') return false
	return /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)
}

/**
 * Opens native or web maps with driving directions to the destination.
 * Uses coordinates when available; otherwise a geocodable address string.
 */
export function getDirectionsUrl(location: DirectionsLocation): string | null {
	const destination = hasValidCoordinates(location.latitude, location.longitude)
		? `${location.latitude},${location.longitude}`
		: formatAddressQuery(location)

	if (!destination) return null

	const encoded = encodeURIComponent(destination)

	if (isAppleDevice()) {
		return `https://maps.apple.com/?daddr=${encoded}&dirflg=d`
	}

	return `https://www.google.com/maps/dir/?api=1&destination=${encoded}`
}

export function openDirections(location: DirectionsLocation): void {
	const url = getDirectionsUrl(location)
	if (!url) return

	window.open(url, '_blank', 'noopener,noreferrer')
}
